import clsx from 'clsx'
import { Fragment } from 'react'

import { Button } from '@wartek-id/button'
import { Separator } from '@wartek-id/separator'
import { Text } from '@wartek-id/text'

import { DataIndukVariant, SatpenStats } from '@/apis/types'

import { LinkWithTracker } from '@/components/LinkWithTracker'

import { VARIANT } from '../../constant'
import { statsToTableArray } from '../../helpers'

interface AreaCardProps {
  title: string
  code: string
  link: string
  additionalParams?: string
  textLink: string
  stats: SatpenStats
  variant?: DataIndukVariant
}

export const AreaCard = ({
  title,
  code,
  link,
  stats,
  textLink,
  additionalParams = '',
  variant = VARIANT.SATPEN,
}: AreaCardProps) => {
  const tables = statsToTableArray(stats, variant)

  const hasFooter = (tables || []).find((i) => i.footer) ?? false
  const tablesBody = (tables || []).filter((i) => !i.footer) || []
  const tablesFooter = (tables || []).filter((i) => i.footer) || []

  return (
    <div>
      <div className="flex flex-col gap-4 rounded border bg-gray-5 p-4 shadow">
        <Text variant="heading-sm" data-testid={`txt-area-${code}`}>
          {title}
        </Text>
        <div className="flex flex-col gap-2">
          {(tablesBody || []).map((row) => (
            <Fragment key={row.id}>
              <div className={clsx('flex justify-between')}>
                <Text
                  variant={row.text === 'Total' ? 'body-sm-bold' : 'body-sm'}
                  color={row.text === 'Total' ? 'default' : 'subdued'}
                >
                  {row.text}
                </Text>
                <Text
                  variant={row.text === 'Total' ? 'body-sm-bold' : 'body-sm'}
                  color={row.text === 'Total' ? 'default' : 'subdued'}
                  data-testid={`txt-item-${code}-${row.id}`}
                >
                  {new Intl.NumberFormat('id-ID', {}).format(row.value)}
                </Text>
              </div>
            </Fragment>
          ))}
          {hasFooter && (
            <>
              <Separator className="mt-4" />
              {(tablesFooter || []).map((row, index) => (
                <Fragment key={row.id}>
                  <div
                    className={clsx(
                      'flex justify-between',
                      hasFooter && row.footer && index === 0 ? 'mt-2' : ''
                    )}
                  >
                    <Text
                      variant={
                        row.text === 'Total' ? 'body-sm-bold' : 'body-sm'
                      }
                      color={row.text === 'Total' ? 'default' : 'subdued'}
                    >
                      {row.text}
                    </Text>
                    <Text
                      variant={
                        row.text === 'Total' ? 'body-sm-bold' : 'body-sm'
                      }
                      color={row.text === 'Total' ? 'default' : 'subdued'}
                      data-testid={`txt-item-${code}-${row.id}`}
                    >
                      {new Intl.NumberFormat('id-ID', {}).format(row.value)}
                    </Text>
                  </div>
                </Fragment>
              ))}
            </>
          )}
        </div>
        <Button
          fullWidth
          as={LinkWithTracker}
          href={`${link}${additionalParams !== '?' ? additionalParams : ''}`}
          size="sm"
          variant="solid"
          color="white"
          className="!bg-gray-5 text-center"
          data-testid={`btn-see-${code}`}
        >
          {textLink}
        </Button>
      </div>
    </div>
  )
}
